import { Star } from "lucide-react";

const StarsDisplay = ({ n }: { n: number }) => (
  <div className="flex items-center gap-0.5">
    {Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        size={13}
        strokeWidth={1.5}
        fill={i < n ? "#f59e0b" : "none"}
        stroke={i < n ? "#f59e0b" : "#d1d5db"}
      />
    ))}
  </div>
);

export default StarsDisplay;